import React from 'react';
import styled from 'styled-components';

const RootContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;

const BackgroundContainer = styled.div`
  width: 100%;
  position: relative;
  top: 32px;
  z-index: 1;
`;

const Background = ({ themeColor }: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2034.9 1281">
    <defs>
      <clipPath id="al">
        <path d="M0 1265.6h1907.7V0H0z" />
      </clipPath>
      <clipPath id="ac">
        <path d="M708.86 309.38h22.356v525.14H708.86z" />
      </clipPath>
      <linearGradient
        id="a"
        x2="1"
        gradientTransform="matrix(22.356 0 0 -22.356 708.86 571.95)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#797979" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.697" stopColor="#b3b3b4" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
      <clipPath id="t">
        <path d="M708.86 309.38c0-2.147 5.005-3.887 11.178-3.887 6.174 0 11.178 1.74 11.178 3.887 0 2.146-5.004 3.887-11.178 3.887-6.173 0-11.178-1.741-11.178-3.887" />
      </clipPath>
      <linearGradient
        id="s"
        x2="1"
        gradientTransform="matrix(22.356 0 0 -22.356 708.86 309.38)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#797979" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.697" stopColor="#b3b3b4" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
      <clipPath id="aq">
        <path d="M708.86 834.53c0-2.146 5.005-3.887 11.178-3.887 6.174 0 11.178 1.741 11.178 3.887s-5.004 3.886-11.178 3.886c-6.173 0-11.178-1.74-11.178-3.886" />
      </clipPath>
      <linearGradient
        id="r"
        x2="1"
        gradientTransform="matrix(22.356 0 0 -22.356 708.86 834.53)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#797979" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.697" stopColor="#b3b3b4" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
      <clipPath id="ap">
        <path d="M1225.7 309.38h22.356v525.14H1225.7z" />
      </clipPath>
      <linearGradient
        id="q"
        x2="1"
        gradientTransform="matrix(22.356 0 0 -22.356 1225.7 571.95)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#797979" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.697" stopColor="#b3b3b4" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
      <clipPath id="ao">
        <path d="M1225.7 309.38c0-2.147 5.004-3.887 11.178-3.887s11.178 1.74 11.178 3.887c0 2.146-5.004 3.887-11.178 3.887s-11.178-1.741-11.178-3.887" />
      </clipPath>
      <linearGradient
        id="p"
        x2="1"
        gradientTransform="matrix(22.356 0 0 -22.356 1225.7 309.38)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#797979" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.697" stopColor="#b3b3b4" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
      <clipPath id="an">
        <path d="M1225.7 834.53c0-2.146 5.004-3.887 11.178-3.887s11.178 1.741 11.178 3.887-5.004 3.886-11.178 3.886-11.178-1.74-11.178-3.886" />
      </clipPath>
      <linearGradient
        id="o"
        x2="1"
        gradientTransform="matrix(22.356 0 0 -22.356 1225.7 834.53)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#797979" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.697" stopColor="#b3b3b4" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
      <clipPath id="am">
        <path d="M595.45 226.73h22.356v666.85H595.45z" />
      </clipPath>
      <linearGradient
        id="n"
        x2="1"
        gradientTransform="matrix(22.356 0 0 -22.356 595.45 560.16)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#797979" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.697" stopColor="#b3b3b4" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
      <clipPath id="ak">
        <path d="M595.45 226.73c0-2.146 5.005-3.887 11.178-3.887s11.178 1.741 11.178 3.887c0 2.147-5.005 3.887-11.178 3.887s-11.178-1.74-11.178-3.887" />
      </clipPath>
      <linearGradient
        id="m"
        x2="1"
        gradientTransform="matrix(22.356 0 0 -22.356 595.45 226.73)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#797979" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.697" stopColor="#b3b3b4" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
      <clipPath id="aj">
        <path d="M595.45 892.11c0-2.147 5.005-3.887 11.178-3.887s11.178 1.74 11.178 3.887c0 2.146-5.005 3.886-11.178 3.886s-11.178-1.74-11.178-3.886" />
      </clipPath>
      <linearGradient
        id="l"
        x2="1"
        gradientTransform="matrix(22.356 0 0 -22.356 595.45 892.11)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#797979" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.697" stopColor="#b3b3b4" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
      <clipPath id="ai">
        <path d="M1334.8 226.73h22.356v666.85H1334.8z" />
      </clipPath>
      <linearGradient
        id="k"
        x2="1"
        gradientTransform="matrix(22.356 0 0 -22.356 1334.8 560.16)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#797979" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.697" stopColor="#b3b3b4" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
      <clipPath id="ah">
        <path d="M1334.8 227.6c0-2.146 5.005-3.887 11.178-3.887 6.174 0 11.177 1.741 11.177 3.887 0 2.147-5.003 3.886-11.177 3.886-6.173 0-11.178-1.739-11.178-3.886" />
      </clipPath>
      <linearGradient
        id="j"
        x2="1"
        gradientTransform="matrix(22.356 0 0 -22.356 1334.8 227.6)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#797979" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.697" stopColor="#b3b3b4" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
      <clipPath id="ag">
        <path d="M1334.8 892.97c0-2.147 5.005-3.887 11.178-3.887 6.174 0 11.177 1.74 11.177 3.887 0 2.146-5.003 3.887-11.177 3.887-6.173 0-11.178-1.741-11.178-3.887" />
      </clipPath>
      <linearGradient
        id="i"
        x2="1"
        gradientTransform="matrix(22.356 0 0 -22.356 1334.8 892.97)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#797979" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.697" stopColor="#b3b3b4" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
      <clipPath id="af">
        <path d="M765.81 529.62h425.78v239.5H765.81z" />
      </clipPath>
      <linearGradient
        id="h"
        x2="1"
        gradientTransform="scale(426.64 -426.64) rotate(33.014 3.944 2.336)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.036" stopColor="#282827" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.552" stopColor="#282827" />
        <stop offset="0.634" stopColor="#282827" />
        <stop offset="0.754" stopColor="#282827" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
      <clipPath id="ae">
        <path d="M0 1265.6h1907.7V0H0z" />
      </clipPath>
      <clipPath id="ad">
        <path d="M379.8 599.97l6-107.21h96.206l5.001 107.21z" />
      </clipPath>
      <linearGradient
        id="g"
        x2="1"
        gradientTransform="matrix(0 107.21 107.21 0 433.41 492.76)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="ab">
        <path d="M379.8 523.37l6-107.21h96.206l5.001 107.21z" />
      </clipPath>
      <linearGradient
        id="f"
        x2="1"
        gradientTransform="matrix(0 107.21 107.21 0 433.41 416.16)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="aa">
        <path d="M379.8 448.82l6-107.21h96.206l5.001 107.21z" />
      </clipPath>
      <linearGradient
        id="e"
        x2="1"
        gradientTransform="matrix(0 107.21 107.21 0 433.41 341.61)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="z">
        <path d="M379.8 372.46l6-107.21h96.206l5.001 107.21z" />
      </clipPath>
      <linearGradient
        id="d"
        x2="1"
        gradientTransform="matrix(0 107.21 107.21 0 433.41 265.25)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="y">
        <path d="M0 1265.6h1907.7V0H0z" />
      </clipPath>
      <clipPath id="x">
        <path d="M1402.1 637.97h211.92v7.696H1402.1z" />
      </clipPath>
      <linearGradient
        id="c"
        x2="1"
        gradientTransform="matrix(211.91 0 0 -211.91 1402.1 641.82)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.427" stopColor="#c7c7c7" />
        <stop offset="0.546" stopColor="#c7c7c7" />
        <stop offset="0.937" stopColor="#515050" />
        <stop offset="1" stopColor="#515050" />
      </linearGradient>
      <clipPath id="w">
        <path d="M0 1265.6h1907.7V0H0z" />
      </clipPath>
      <clipPath id="v">
        <path d="M1402.1 201.02h211.92v7.696H1402.1z" />
      </clipPath>
      <linearGradient
        id="b"
        x2="1"
        gradientTransform="matrix(211.91 0 0 -211.91 1402.1 204.87)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.427" stopColor="#c7c7c7" />
        <stop offset="0.546" stopColor="#c7c7c7" />
        <stop offset="0.937" stopColor="#515050" />
        <stop offset="1" stopColor="#515050" />
      </linearGradient>
      <clipPath id="u">
        <path d="M0 1265.6h1907.7V0H0z" />
      </clipPath>
    </defs>
    <path
      fill="#e6e7e8"
      d="M0 0h-1516.2l257.14 178.34h992.22z"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4) translate(1736.8 164.19)"
    />
    <path
      fill={themeColor || '#ec1c24'}
      stroke={themeColor || '#ec1c24'}
      strokeMiterlimit="10"
      strokeWidth="10"
      d="M220.6 146.28h1516.2v18.057H220.6z"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    />
    <path
      fill={themeColor || '#be1e2d'}
      d="M1129.3 309.38H830.68v523.08h298.62z"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    />
    <g
      clipPath="url(#al)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path
        fill={themeColor || '#ec1c24'}
        d="M0 0c0-22.49-186.76-40.721-417.15-40.721C-647.53-40.721-834.3-22.49-834.3 0s186.76 40.721 417.15 40.721C-186.77 40.721 0 22.49 0 0"
        transform="translate(1393.4 969.88)"
      />
      <path
        fill="none"
        stroke={themeColor || '#ec1c24'}
        strokeMiterlimit="10"
        strokeWidth="10"
        d="M0 0c0-22.49-186.76-40.721-417.15-40.721C-647.53-40.721-834.3-22.49-834.3 0s186.76 40.721 417.15 40.721C-186.77 40.721 0 22.49 0 0z"
        transform="translate(1393.4 969.88)"
      />
      <path
        fill={themeColor || '#ec1c24'}
        stroke={themeColor || '#ec1c24'}
        strokeMiterlimit="10"
        strokeWidth="10"
        d="M0 0v-96.697h834.3V0"
        transform="translate(559.11 969.88)"
      />
      <path
        fill={themeColor || '#ec1c24'}
        d="M0 0c0-22.49-183.36-40.721-409.55-40.721-226.18 0-409.54 18.231-409.54 40.721s183.36 40.721 409.54 40.721C-183.36 40.721 0 22.49 0 0"
        transform="translate(1385.7 873.18)"
      />
      <path
        fill="none"
        stroke={themeColor || '#af1023'}
        strokeMiterlimit="10"
        strokeWidth="29"
        d="M0 0c0-22.49-183.36-40.721-409.55-40.721-226.18 0-409.54 18.231-409.54 40.721s183.36 40.721 409.54 40.721C-183.36 40.721 0 22.49 0 0z"
        transform="translate(1385.7 873.18)"
      />
    </g>
    <g
      clipPath="url(#ac)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path fill="url(#a)" d="M708.86 309.38h22.356v525.14H708.86z" />
    </g>
    <g
      clipPath="url(#t)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path
        fill="url(#s)"
        d="M708.86 309.38c0-2.147 5.005-3.887 11.178-3.887 6.174 0 11.178 1.74 11.178 3.887 0 2.146-5.004 3.887-11.178 3.887-6.173 0-11.178-1.741-11.178-3.887"
      />
    </g>
    <g
      clipPath="url(#aq)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path
        fill="url(#r)"
        d="M708.86 834.53c0-2.146 5.005-3.887 11.178-3.887 6.174 0 11.178 1.741 11.178 3.887s-5.004 3.886-11.178 3.886c-6.173 0-11.178-1.74-11.178-3.886"
      />
    </g>
    <g
      clipPath="url(#ap)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path fill="url(#q)" d="M1225.7 309.38h22.356v525.14H1225.7z" />
    </g>
    <g
      clipPath="url(#ao)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path
        fill="url(#p)"
        d="M1225.7 309.38c0-2.147 5.004-3.887 11.178-3.887s11.178 1.74 11.178 3.887c0 2.146-5.004 3.887-11.178 3.887s-11.178-1.741-11.178-3.887"
      />
    </g>
    <g
      clipPath="url(#an)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path
        fill="url(#o)"
        d="M1225.7 834.53c0-2.146 5.004-3.887 11.178-3.887s11.178 1.741 11.178 3.887-5.004 3.886-11.178 3.886-11.178-1.74-11.178-3.886"
      />
    </g>
    <g
      clipPath="url(#am)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path fill="url(#n)" d="M595.45 226.73h22.356v666.85H595.45z" />
    </g>
    <g
      clipPath="url(#ak)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path
        fill="url(#m)"
        d="M595.45 226.73c0-2.146 5.005-3.887 11.178-3.887s11.178 1.741 11.178 3.887c0 2.147-5.005 3.887-11.178 3.887s-11.178-1.74-11.178-3.887"
      />
    </g>
    <g
      clipPath="url(#aj)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path
        fill="url(#l)"
        d="M595.45 892.11c0-2.147 5.005-3.887 11.178-3.887s11.178 1.74 11.178 3.887c0 2.146-5.005 3.886-11.178 3.886s-11.178-1.74-11.178-3.886"
      />
    </g>
    <g
      clipPath="url(#ai)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path fill="url(#k)" d="M1334.8 226.73h22.356v666.85H1334.8z" />
    </g>
    <g
      clipPath="url(#ah)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path
        fill="url(#j)"
        d="M1334.8 227.6c0-2.146 5.005-3.887 11.178-3.887 6.174 0 11.177 1.741 11.177 3.887 0 2.147-5.003 3.886-11.177 3.886-6.173 0-11.178-1.739-11.178-3.886"
      />
    </g>
    <g
      clipPath="url(#ag)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path
        fill="url(#i)"
        d="M1334.8 892.97c0-2.147 5.005-3.887 11.178-3.887 6.174 0 11.177 1.74 11.177 3.887 0 2.146-5.003 3.887-11.177 3.887-6.173 0-11.178-1.741-11.178-3.887"
      />
    </g>
    <g
      clipPath="url(#af)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path fill="url(#h)" d="M765.81 529.62h425.78v239.5H765.81z" />
    </g>
    <g
      clipPath="url(#ae)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path
        fill="none"
        stroke="#59595c"
        strokeMiterlimit="10"
        strokeWidth="7"
        d="M1191.6 529.62H765.82v239.5h425.78z"
      />
      <path
        fill="#404041"
        d="M0 0h-171.96l16 410.55H-14z"
        transform="translate(519.67 205.11)"
      />
      <path
        fill="#bbbdbf"
        d="M0 0h-120.96l-10 410.55H11z"
        transform="translate(494.67 205.11)"
      />
    </g>
    <g
      clipPath="url(#ad)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path
        fill="url(#g)"
        d="M379.8 599.97l6-107.21h96.206l5.001 107.21z"
      />
    </g>
    <g
      clipPath="url(#ab)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path
        fill="url(#f)"
        d="M379.8 523.37l6-107.21h96.206l5.001 107.21z"
      />
    </g>
    <g
      clipPath="url(#aa)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path
        fill="url(#e)"
        d="M379.8 448.82l6-107.21h96.206l5.001 107.21z"
      />
    </g>
    <g
      clipPath="url(#z)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path
        fill="url(#d)"
        d="M379.8 372.46l6-107.21h96.206l5.001 107.21z"
      />
    </g>
    <g
      clipPath="url(#y)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path fill="#404041" d="M536.04 197.32H330.76v15.574h205.28z" />
      <path fill="#d0d2d3" d="M1608.1 207.98h-200v430h200z" />
    </g>
    <g
      clipPath="url(#x)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path fill="url(#c)" d="M1402.1 637.97h211.92v7.696H1402.1z" />
    </g>
    <g
      clipPath="url(#w)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path fill="#282827" d="M1402.5 634.27h-3.83v15.096h3.83z" />
      <path fill="#515050" d="M1617.9 634.27h-3.829v15.096h3.829z" />
    </g>
    <g
      clipPath="url(#v)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path fill="url(#b)" d="M1402.1 201.02h211.92v7.696H1402.1z" />
    </g>
    <g
      clipPath="url(#u)"
      transform="matrix(1.3333 0 0 -1.3333 -287.46 1469.4)"
    >
      <path fill="#282827" d="M1402.5 197.32h-3.83v15.096h3.83z" />
      <path fill="#515050" d="M1617.9 197.32h-3.829v15.096h3.829z" />
      <path
        fill={themeColor || '#ec1c24'}
        d="M0 0c-89.964 0-162.89-7.088-162.89-15.83S-89.96-31.66 0-31.66s162.89 7.088 162.89 15.83S89.961 0 0 0"
        transform="translate(979.94 211.13)"
      />
      <path fill={themeColor || '#ec1c24'} d="M817.05 195.3h325.79v19.063H817.05z" />
      <path
        fill={themeColor || '#a51627'}
        d="M0 0c0-8.742-72.93-15.829-162.89-15.829S-325.78-8.742-325.78 0c0 8.743 72.931 15.83 162.89 15.83S0 8.743 0 0"
        transform="translate(1142.8 214.37)"
      />
      <path fill="#bbbdbf" d="M1129.9 219.31H829.31v200.36h300.59z" />
      <path
        fill="#bbbdbf"
        d="M0 0c0-7.983-67.289-14.456-150.29-14.456S-300.58-7.983-300.58 0s67.288 14.456 150.29 14.456S0 7.983 0 0"
        transform="translate(1129.9 220.53)"
      />
      <path
        fill={themeColor || '#ec1c24'}
        d="M0 0c-89.964 0-162.89-7.087-162.89-15.83S-89.96-31.66 0-31.66s162.89 7.087 162.89 15.83S89.961 0 0 0"
        transform="translate(979.94 432.27)"
      />
      <path fill={themeColor || '#ec1c24'} d="M817.05 416.44h325.79v19.064H817.05z" />
      <path
        fill={themeColor || '#a51627'}
        d="M0 0c0-8.743-72.93-15.83-162.89-15.83S-325.78-8.743-325.78 0s72.931 15.83 162.89 15.83S0 8.743 0 0"
        transform="translate(1142.8 435.5)"
      />
      <path
        fill="#e6e7e8"
        stroke="#bbbdbf"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M1287.9 868.14H669.51v231.9h618.39z"
      />
    </g>
  </svg>
);

export interface BoothBackgroundProps {
  themeColor?: string;
}

const BoothBackground: React.FC<BoothBackgroundProps> = ({ themeColor }: BoothBackgroundProps) => (
  <RootContainer>
    <BackgroundContainer>
      <Background themeColor={themeColor} />
    </BackgroundContainer>
  </RootContainer>
);

export default BoothBackground;
